import { render, staticRenderFns } from "./1abe40f6-b4e6-49ec-8d3c-07bd097f6315.vue?vue&type=template&id=4585a7a7&scoped=true"
import script from "./1abe40f6-b4e6-49ec-8d3c-07bd097f6315.vue?vue&type=script&lang=ts"
export * from "./1abe40f6-b4e6-49ec-8d3c-07bd097f6315.vue?vue&type=script&lang=ts"
import style0 from "./1abe40f6-b4e6-49ec-8d3c-07bd097f6315.vue?vue&type=style&index=0&id=4585a7a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4585a7a7",
  null
  
)

export default component.exports